import React, { useRef, useContext, useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

import Templete from "../../Templete/Templete";

import AuthService from "../../../../services/User/AuthService";
import WalletService from "../../../../services/User/WalletService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";
import QRCodeDialog from "./QrCodeDialog";

const FundRequest = () => {
  const history = useHistory();

  const loadingCtx = useContext(LoadingContext);

  const [bankList, setBankList] = useState();
  const [selectedBank, setSelectedBank] = useState();

  const [paymentDate, setPaymentDate] = useState();

  const formRef = useRef();
  const amountRef = useRef();
  const paymentRefIdRef = useRef();
  const remarkRef = useRef();

  const submitHandler = async () => {
    const amount = amountRef.current.value;
    const paymentRefId = paymentRefIdRef.current.value;
    const remark = remarkRef.current.value;

    if (!selectedBank) {
      Swal.fire("Opps!", "Invalid Bank", "error");
      return;
    }

    if (!amount || amount < 1) {
      Swal.fire("Opps!", "Invalid Amount", "error");
      return;
    }

    if (!paymentDate) {
      Swal.fire("Opps!", "Invalid Payment Date", "error");
      return;
    }

    if (!paymentRefId) {
      Swal.fire("Opps!", "Invalid Payment REF ID", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await WalletService.fundRequest(
        token,
        selectedBank
          ? `${selectedBank.bank_name} (${selectedBank.account_number} - ${selectedBank.upi_id})`
          : null,
        amount,
        paymentDate,
        paymentRefId,
        remark
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        formRef.current.reset();
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  useEffect(() => {
    fetchAllBanks();

    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    setPaymentDate(formattedDate);
  }, []);

  const fetchAllBanks = async () => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await WalletService.fetchAllBanks(token);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        const data = responseData.data;
        setBankList(data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const [open, setOpen] = useState(false);
  const [upiIntent, setUpiIntent] = useState();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-default">
            <div class="card-header">
              <div class="card-tools">
                <button
                  type="button"
                  className="btn btn-primary btn-sm ml-2"
                  onClick={() => {
                    history.push("/user/fund_request_history");
                  }}
                >
                  Fund Request History
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-10 mx-auto">
                <div class="card-body">
                  <form ref={formRef} autoComplete="off">
                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label">Select Bank</label>
                      <div class="col-sm-9">
                        <Autocomplete
                          options={bankList}
                          getOptionLabel={(option) => option.bank_name}
                          renderInput={(params) => (
                            <TextField {...params} label="Select Bank" />
                          )}
                          onChange={(e, v) => {
                            setSelectedBank(v ? v : null);
                          }}
                        />

                        {selectedBank && (
                          <div className="pt-4">
                            <p>
                              <strong>Bank Name:</strong>{" "}
                              {selectedBank.bank_name}
                            </p>
                            <p>
                              <strong>Account Name:</strong>{" "}
                              {selectedBank.account_name}
                            </p>
                            <p>
                              <strong>Account Number:</strong>{" "}
                              {selectedBank.account_number}
                            </p>
                            <p className="d-flex justify-content-between align-items-center">
                              <span>
                                <strong>UPI ID:</strong> {selectedBank.upi_id}
                              </span>
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  var upiIntent = `upi://pay?pa=${
                                    selectedBank.upi_id
                                  }&pn=${encodeURIComponent(
                                    selectedBank.account_name
                                  )}&cu=INR`;
                                  setUpiIntent(upiIntent);
                                  handleOpen();
                                }}
                              >
                                Show QR Code
                              </button>
                            </p>
                            <p>
                              <strong>IFSC Code:</strong>{" "}
                              {selectedBank.ifsc_code}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label">Amount</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Amount"
                          ref={amountRef}
                        />
                        <small style={{ color: "red" }}>Minimum: ₹100</small>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label">
                        Payment Date
                      </label>
                      <div class="col-sm-9">
                        <input
                          type="date"
                          class="form-control"
                          placeholder="Payment Date"
                          value={paymentDate}
                          onChange={(e) => setPaymentDate(e.target.value)} // Optional, if user can change date
                        />
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label">
                        Payment REF ID
                      </label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Reference ID (UTR/RRN)"
                          ref={paymentRefIdRef}
                        />
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-sm-3 col-form-label">Remark</label>
                      <div class="col-sm-9">
                        <textarea
                          type="date"
                          class="form-control"
                          ref={remarkRef}
                        ></textarea>
                      </div>
                    </div>

                    <div class="text-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        onClick={submitHandler}
                      >
                        Submit Fund Request
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <QRCodeDialog
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        upiIntent={upiIntent}
      />
    </React.Fragment>
  );
};

export default FundRequest;
